export default {
  myLocation: {
    stopShowingCurrentLocation: 'Clique para parar de mostrar sua localização atual',
    showCurrentLocation: 'Clique para mostrar sua localização atual',
    yourCurrentLocation: 'Sua localização atual',
    continuously: 'Continuamente',
    onlyOnce: 'Somente uma vez',
    continuouslyLocation: 'Atualiza a sua posição a cada 2 segundos',
    onlyOnceLocation: 'Acessar sua posição apenas uma vez',
    myPositionToolTip: 'Ative a localização para mostrar sua posição e encontrar lugares próximos mais facilmente'
  }
}
